import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import moment from 'moment';

import icon from '../../assets/icon_card_2.svg';
import grayCheckIcon from '../../assets/check_circle_gray.svg';
import blueCheckIcon from '../../assets/check_circle_blue.svg';
import { TESTS } from '../../utils/testScoreUtils';

interface LatestTestResults {
  [testType: string]: {
    // e.g., phq-9: { _id: string, createdAt: string, score: number, ... }
    createdAt: string;
    score: number;
  };
}

const TestListPage: React.FC = () => {
  const [latestResults, setLatestResults] = useState<LatestTestResults>({});

  useEffect(() => {
    const fetchLatestResults = async () => {
      try {
        const response = await axios.get<LatestTestResults>('/api/test-results/latest-by-type');
        setLatestResults(response.data);
      } catch (error) {
        console.error('에러발생에러발생!!!!:', error);
      }
    };
    fetchLatestResults();
  }, []);

  const formatLastTestedDate = (testId: string) => {
    const result = latestResults[testId];

    console.log(result, '==========result');

    if (result && result.createdAt && result.score >= 0) {
      return `마지막 검사: ${moment(result.createdAt).format('YYYY.MM.DD')}일 / 검사 결과: ${result.score}점`;
    }
    return '아직 검사 기록이 없습니다.';
  };

  return (
    <div className="app-container test-list-page">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">심리 검사</h2>
        <p className="page-header__subtitle">다양한 검사를 통해 자신의 마음 상태를 점검해보세요.</p>
      </div>
      <div className="test-list">
        {TESTS.map(test => {
          const hasResult = !!latestResults[test.id];
          const iconToShow = hasResult ? blueCheckIcon : grayCheckIcon;
          return (
            <Link to={test.path} key={test.id} className="test-card">
              <div className={`test-card__last-tested ${hasResult ? 'has-result' : ''}`}>
                <img src={iconToShow} alt="check icon" />
                <span>{formatLastTestedDate(test.id)}</span>
              </div>
              <h3>{test.title}</h3>
              <p>{test.description}</p>
              <div className="test-card__action">
                <span>검사 시작하기 →</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TestListPage;
